// extracted by mini-css-extract-plugin
export default {"card":"InfoCard_card__GiuGT","cardDetails":"InfoCard_cardDetails__FViDg","headingText":"InfoCard_headingText__MW8WF","subHeadingText":"InfoCard_subHeadingText__wmzy6"};